import { CheckCircle, XCircle } from "lucide-react";

export default function Toast({ message, type = "success", onClose }) {
  if (!message) return null;

  return (
    <div className="fixed bottom-6 right-20 z-100">
      <div
        className={`flex items-center gap-3 px-5 py-3 rounded-xl shadow-lg text-sm font-semibold
        ${type === "success"
          ? "bg-black text-white"
          : "bg-red-600 text-white"}`}
      >
        {type === "success" ? <CheckCircle size={18} /> : <XCircle size={18} />}
        <span>{message}</span>
        <button onClick={onClose} className="ml-2 opacity-80 hover:opacity-100">
          ✕
        </button>
      </div>
    </div>
  );
}
